'use client';

import classNames from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';

import { Link } from '@/components/link';

import { formatAnchorId } from '.';

const OFFSET_TOP = 150;

const isInViewport = (element) => {
  if (!element) {
    return false;
  }

  const rect = element.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const SummaryClient = ({ summary }) => {
  const ref = useRef(null);
  const [current, setCurrent] = useState(null);

  const handleScroll = useCallback(() => {
    for (let index = summary.length - 1; index >= 0; index--) {
      const section = summary[index];

      let sectionElement;

      try {
        sectionElement = document.querySelector(
          `#${formatAnchorId(section.title)}`,
        );
      } catch (error) {}

      if (sectionElement) {
        const sectionTop = sectionElement.getBoundingClientRect().top;

        if (sectionTop <= OFFSET_TOP) {
          setCurrent(index);

          // if (isInViewport(ref.current)) {
          //   setOpen(index);
          // }

          // const subList = section.content.filter((subSection) => {
          //   return subSection.component === 'article_section';
          // });

          // if (subList.length > 0) {
          //   for (let subIndex = subList.length - 1; subIndex >= 0; subIndex--) {
          //     const subSectionElement = document.querySelector(
          //       `#${formatAnchorId(subList[subIndex].title)}`,
          //     );

          //     if (subSectionElement) {
          //       const subSectionTop =
          //         subSectionElement.getBoundingClientRect().top;

          //       if (subSectionTop <= OFFSET_TOP) {
          //         setSubCurrent(subIndex);

          //         return;
          //       }
          //     }
          //   }
          // }

          // setSubCurrent(null);

          return;
        }
      }
    }

    setCurrent(null);
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll, {
        passive: true,
      });

      handleScroll();

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [handleScroll]);

  return summary?.length > 0 ? (
    <div ref={ref} className="summary">
      <ul>
        {summary.map((item, index) => {
          return (
            <li key={item.title}>
              <Link
                href={`#${formatAnchorId(item.title)}`}
                className={classNames('summary__heading', {
                  'summary__heading--active':
                    current === index || (current === null && index === 0),
                })}
              >
                {item.title}
              </Link>

              {item.sub?.length > 0 ? (
                <ul>
                  {item.sub.map((subItem) => {
                    return (
                      <li key={subItem.title}>
                        <Link
                          href={`#${formatAnchorId(subItem.title)}`}
                          className="summary__heading"
                        >
                          {subItem.title}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
};
